export default __webpack_public_path__ + "static/media/heart.fb824694.svg";